import React from "react";
import { RowColors, TableSection } from "../TableSection/TableSection";
import {RowOptions } from "../TableSection/TableSection";
import AssignmentsLogo from "../../Photos/assignments-text.svg"
import "./Assignments.scss"
import { SectionProps } from "../../App";

/**
 * Returns whether or not <assignment> should appear as released yet
 * @param assignment the assignment that should or should not be released
 * @return true if "now" is after/on the release date, false otherwise
 */
function shouldRelease(assignment: RowOptions): boolean {
    if (assignment.autoReleaseDate === undefined) {
      return true; // If no defined release date, treat it as released if it has an href
    }
    const now = new Date();
    // Convert now into EST, if it isn't already
    const nowEST = new Date(
        now.toLocaleString("en-US", {
        timeZone: "America/New_York",
    })
    );
    return nowEST > new Date(assignment.autoReleaseDate);
}


/**
 * Returns whether or not <assignment> should appear as locked
 * @param assignment the assignment that should or should not be locked
 * @return true if "now" is after/on the due date, false otherwise
 */
function pastDue(assignment: RowOptions): boolean {
    if (assignment.dueDate === undefined) {
      return false;
    }
  
    const now = new Date();
  
    // Convert now into EST, if it isn't already
    const nowEST = new Date(
      now.toLocaleString("en-US", {
        timeZone: "America/New_York",
      })
    );
  
    return nowEST > new Date(assignment.dueDate);
}

export class Assignments extends React.Component<SectionProps> {
  myHeader: string[] = [
    "Assignment",
    "Released",
    "Early",
    "On Time",
    "Late",
    "JavaDocs",
    "Help Slides",
    "Help Session",
    "Additional Handouts",
  ];

  myRows: RowOptions[] = [
    {
      cellNames: ["Rattytouille", "9/10", "—", "9/13", "—", "—", "—", "—", "—"],
      cellNametoLinks: new Map<string, string>([
        [
          "Rattytouille",
          "https://cs15-hedgedoc-production.up.railway.app/s/M7Ne7yhLX",
        ],
      ]),
      autoReleaseDate: "Sep 10, 2025 16:00:00 EDT",
      dueDate: "Sep 13, 2025 23:59:00 EDT",
    },

    {
      cellNames: [
        "AndyBot",
        "9/14",
        "—",
        "9/17",
        "—",
        "JavaDocs",
        "—",
        "—",
        "—",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "AndyBot",
          "https://cs15-hedgedoc-production.up.railway.app/s/PnfPlQv96",
        ],
        [
          "JavaDocs",
          "https://cs.brown.edu/courses/cs015/javadocs/cs15/prj/andyBotSupport/package-summary.html",
        ],
      ]),
      autoReleaseDate: "Sep 14, 2025 15:00:00 EDT",
      dueDate: "Sep 17, 2025 23:59:00 EDT",
    },

    {
      cellNames: ["Pong", "9/18", "—", "9/22", "—", "JavaDocs", "—", "—", "—"],
      cellNametoLinks: new Map<string, string>([
        ["Pong", "https://cs15-hedgedoc-production.up.railway.app/s/I0rfEsBic"],
        [
          "JavaDocs",
          "https://cs.brown.edu/courses/cs015/javadocs/cs15/prj/pongSupport/package-summary.html",
        ],
      ]),
      autoReleaseDate: "Sep 18, 2025 16:00:00 EDT",
      dueDate: "Sep 22, 2025 23:59:00 EDT",
    },

    {
      cellNames: [
        "TicTacToe",
        "9/23",
        "9/25",
        "9/27",
        "9/29",
        "JavaDocs",
        "—",
        "—",
        "—",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "TicTacToe",
          "https://cs15-hedgedoc-production.up.railway.app/s/x3_vSzKoP",
        ],
        [
          "JavaDocs",
          "https://cs.brown.edu/courses/cs015/javadocs/cs15/prj/ticTacToeSupport/package-summary.html",
        ],
      ]),
      autoReleaseDate: "Sep 23, 2025 16:00:00 EDT",
      dueDate: "Sep 29, 2025 23:59:00 EDT",
    },

    {
      cellNames: [
        "Fruit Ninja",
        "9/30",
        "10/5",
        "10/7",
        "10/9",
        "JavaDocs",
        "Help Slides",
        "—",
        "—",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "Fruit Ninja",
          "https://cs15-hedgedoc-production.up.railway.app/s/c5_2bnKZy",
        ],
        [
          "JavaDocs",
          "https://cs.brown.edu/courses/csci0150/javadocs/cs15/prj/fruitNinjaSupport/package-summary.html",
        ],
        [
          "Help Slides",
          "https://docs.google.com/presentation/d/1M_Cx1R4mPssLFIwLJ3G9S0tL3a8wTTXn8jqWyWJtMGA/edit?usp=sharing",
        ],
      ]),
      autoReleaseDate: "Sep 30, 2025 16:00:00 EDT",
      dueDate: "Oct 9, 2025 23:59:00 EDT",
    },

    {
      cellNames: [
        "Cartoon",
        "10/9",
        "10/16",
        "10/18",
        "10/20",
        "—",
        "Help Slides",
        "—",
        "Mini Assignment",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "Cartoon",
          "https://cs15-hedgedoc-production.up.railway.app/s/SjEiPB0SK",
        ],
        [
          "Help Slides",
          "https://docs.google.com/presentation/d/1d_6SsEQXPfT0hYosnYOT3L3Vu46SYEkhBryWxszJnHw/edit?usp=sharing",
        ],
        [
          "Mini Assignment",
          "https://cs15-hedgedoc-production.up.railway.app/s/AM3HYOmuI",
        ],
      ]),
      autoReleaseDate: "Oct 9, 2025 16:00:00 EDT",
    },

    {
      cellNames: [
        "DoodleJump",
        "10/21",
        "10/27",
        "10/29",
        "10/31",
        "—",
        "Help Slides",
        "—",
        "—",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "DoodleJump",
          "https://cs15-hedgedoc-production.up.railway.app/s/Tlm4nzBUh",
        ],
        [
          "Help Slides",
          "https://docs.google.com/presentation/d/1YXao19tXXhYcrKw8XAa7yTic-WZhTHZnBuyiz8US2W8/edit?slide=id.p3#slide=id.p3",
        ],
      ]),
      autoReleaseDate: "Oct 21, 2025 16:00:00 EDT",
    },

    {
      cellNames: [
        "Tetris",
        "11/1",
        "11/8",
        "11/10",
        "11/12",
        "—",
        "Help Slides",
        "—",
        "—",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "Tetris",
          "https://cs15-hedgedoc-production.up.railway.app/s/7pYzFUyxc",
        ],
        [
          "Help Slides",
          "https://docs.google.com/presentation/d/1KNoJigAvdioLop-5IHHcn5S_Yk8BAlyA8tUOLOfivzE/edit?usp=sharing",
        ],
      ]),
      autoReleaseDate: "Nov 1, 2025 16:00:00 EDT",
    },

    {
      cellNames: [
        "PacMan",
        "11/13",
        "12/7",
        "12/9",
        "12/11",
        "—",
        "Help Slides",
        "Help Session",
        "—",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PacMan",
          "https://cs15-hedgedoc-production.up.railway.app/s/0LA5JpKmR",
        ],
        [
          "Help Slides",
          "https://docs.google.com/presentation/d/1zip39UNDKGwVF4cJBYVABsJM5q2je6cNZtHQRo7OC9A/edit?usp=sharing",
        ],
        ["Help Session", "https://www.youtube.com/watch?v=rUt5iMBs-TM"],
      ]),
      autoReleaseDate: "Nov 13, 2025 16:00:00 EST",
    },

    //TODO: help slides and help session link
    {
      cellNames: [
        "Sketchy",
        "11/13",
        "12/7",
        "12/9",
        "12/11",
        "JavaDocs",
        "Help Slides",
        "Help Session",
        "—",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "Sketchy",
          "https://cs15-hedgedoc-production.up.railway.app/s/JSGAH187J",
        ],
        [
          "JavaDocs",
          "https://cs.brown.edu/courses/cs015/javadocs/cs15/fnl/sketchySupport/FileIO.html",
        ],
        [
          "Help Slides",
          "https://docs.google.com/presentation/d/1Xaw42FHxe1dgOxe7I5_fGp09e65kK4zYwJV2TU4VA8o/edit?usp=sharing",
        ],
        ["Help Session", ""],
      ]),
      autoReleaseDate: "Nov 13, 2025 16:00:00 EST",
    },

    //TODO: help slides and help session link
    {
      cellNames: [
        "Othello",
        "11/13",
        "12/7",
        "12/9",
        "12/11",
        "—",
        "Help Slides",
        "Help Session",
        "AI Handout",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "Othello",
          "https://cs15-hedgedoc-production.up.railway.app/s/QYtTExtRB",
        ],
        ["Help Slides", ""],
        ["Help Session", ""],
        ["AI Handout", ""],
      ]),
      autoReleaseDate: "Nov 13, 2025 16:00:00 EST",
    },

    //TODO: help slides and help session link
    {
      cellNames: [
        "Indy",
        "11/13",
        "12/7",
        "12/9",
        "12/11",
        "—",
        "—",
        "—",
        "Mini-Assignment",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "Indy",
          "https://cs15-hedgedoc-production.up.railway.app/WT_kSOogTLSVZnwn8bX6WA?view",
        ],
        ["Mini-Assignment", ""],
      ]),
      autoReleaseDate: "Nov 13, 2025 16:00:00 EST",
    },
  ];

  render() {
    // Modify the cellNametoLinks map based on the release status
    const modifiedRows: RowOptions[] = this.myRows.map((row) => {
      if (!shouldRelease(row)) {
        const updatedLinks = new Map<string, string>();

        // Iterate over the original links and replace or remove them if necessary
        row.cellNametoLinks.forEach((value, key) => {
          updatedLinks.set(key, "");
        });

        return {
          ...row,
          cellNametoLinks: updatedLinks,
          backgroundColor: RowColors.LOCKED,
        };
      } else if (pastDue(row)) {
        return {
          ...row,
          backgroundColor: RowColors.FINISHED,
        };
      } else {
        return {
          ...row,
          backgroundColor: RowColors.RELEASED,
        };
      }
      return row;
    });

    return (
      <section
        id="assignments"
        className={`anchor assignments ${this.props.static ? "static" : ""}`}
      >
        <center>
          <div className="header-container">
            <img
              className="assignments-logo logo"
              src={AssignmentsLogo}
              alt="assignments text"
            />
          </div>
        </center>
        <TableSection header={this.myHeader} rows={modifiedRows} />
      </section>
    );
  }
}

